import { render, staticRenderFns } from "./imgSlider.vue?vue&type=template&id=1640dccc&scoped=true"
import script from "./imgSlider.vue?vue&type=script&lang=js"
export * from "./imgSlider.vue?vue&type=script&lang=js"
import style0 from "./imgSlider.vue?vue&type=style&index=0&id=1640dccc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1640dccc",
  null
  
)

export default component.exports